export const approxCalorieCounter = (identifier, distance) => {
  switch (identifier) {
    case 'W':
      return distance * 85;
    case 'R':
      return distance * 120;
    case 'C':
      return distance * 60;
    case 'S':
      return distance * 544;
    case 'O':
      return distance * 75;
  }
};
